export default "__VITE_ASSET__B8YapJet__"